// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../settlement-no-registration/state/report';
import actions from '../../actions-list';

const updateSettlementNoRegistrationReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_SETTLEMENT_NO_REGISTRATION_REPORT_SUCCESS]: updateSettlementNoRegistrationReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateSettlementNoRegistrationReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/reducers/report.js